import { Routes, Route } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { Marquee } from "@/components/site/Marquee";
import { Expertises } from "@/components/site/Expertises";
import { Methode } from "@/components/site/Methode";
import { Realisations } from "@/components/site/Realisations";
import { Professionnels } from "@/components/site/Professionnels";
import { APropos } from "@/components/site/APropos";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { MentionsLegales, PolitiqueConfidentialite } from "@/components/site/Legal";
import { ServicePage, NotFound } from "@/components/site/ServicePage";

export const Home = () => (
  <>
    <Header />
    <main>
      <Hero />
      <TrustBar />
      <Marquee />
      <Expertises />
      <Methode />
      <Realisations />
      <Professionnels />
      <APropos />
      <Contact />
    </main>
    <Footer />
  </>
);

export const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/mentions-legales" element={<MentionsLegales />} />
    <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
    <Route path="/plaquiste-seine-et-marne" element={<ServicePage slug="plaquiste-seine-et-marne" />} />
    <Route path="/isolation-interieure-seine-et-marne" element={<ServicePage slug="isolation-interieure-seine-et-marne" />} />
    <Route path="/faux-plafonds-seine-et-marne" element={<ServicePage slug="faux-plafonds-seine-et-marne" />} />
    <Route path="/amenagement-interieur-seine-et-marne" element={<ServicePage slug="amenagement-interieur-seine-et-marne" />} />
    <Route path="/architectes-maitres-oeuvre" element={<ServicePage slug="architectes-maitres-oeuvre" />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);
